module.exports = __webpack_public_path__ + "img/download.f1acd502.svg";